import moment from "moment";
import { set as dotPropSet } from "dot-prop-immutable";
import {
  INITIALIZE_DEEP_DIVE_FORM,
  UPDATE_DEEP_DIVE_FORM,
  UPDATE_DEEP_DIVE_FORM_AT,
  LOAD_DEEP_DIVE_STORIES,
  VALIDATE_DEEP_DIVE_FORM_FAILED,
  VALIDATE_DEEP_DIVE_FORM_SUCCEEDED,
  DEEP_DIVE_EDITOR_SAVE_FAILED,
  DEEP_DIVE_EDITOR_SAVE_SUCCEEDED,
} from "deepDiveEditor/actions/form";

export const parseDate = dateString => {
  const date = moment(dateString, moment.ISO_8601);
  return date.isValid() ? date : null;
};

export const defaultState = {
  errors: {},
};

export const deepDiveInitialState = {
  errors: {},
  loadedStories: {},
  id: null,
  slug: null,
  front_cover: null,
  published_date: null,
  created_date: null,
  sponsored_text: "",
  bg_color: "#f5f5f5",
  outline_color: "#bababe",
  text_color: "#656568",
  ad_positions: null,
  numbering_override: {},
  public: false,
  stories: [],
  wordcount: 0,
  reading_mins: "0",
  series: null,
};

export default function(state = deepDiveInitialState, action) {
  switch (action.type) {
    case INITIALIZE_DEEP_DIVE_FORM:
      return {
        ...defaultState,
        ...action.payload,
        created_date: parseDate(action.payload.created_date),
        published_date: parseDate(action.payload.published_date),
      };

    case UPDATE_DEEP_DIVE_FORM:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_DEEP_DIVE_FORM_AT:
      return dotPropSet(state, action.payload.path, action.payload.value);

    case LOAD_DEEP_DIVE_STORIES:
      return {
        ...state,
        loadedStories: {
          ...state.loadedStories,
          ...action.payload.reduce(
            (loadedStories, item) => ({ ...loadedStories, [item.id]: item }),
            {}
          ),
        },
      };
    case VALIDATE_DEEP_DIVE_FORM_FAILED:
    case DEEP_DIVE_EDITOR_SAVE_FAILED:
      return { ...state, errors: action.payload };
    case VALIDATE_DEEP_DIVE_FORM_SUCCEEDED:
    case DEEP_DIVE_EDITOR_SAVE_SUCCEEDED:
      return { ...state, errors: {} };
    default:
      return state;
  }
}
